/**
 * @generated SignedSource<<a417b90d478ccce10dc6764baf9149ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Page_page",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Subscription_subscribable"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSections_page"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Breadcrumbs_page"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ResourceTreeTaxonomy",
      "kind": "LinkedField",
      "name": "taxonomies",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TaxonomyIcons_taxonomies"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Page",
  "abstractKey": null
};

node.hash = "b03f3c7ec4a27fa92f78ff276669ffc5";

module.exports = node;
